<template>
    <div :class="{resetPassword:!isMobile,mresetPassword:isMobile,mobileCommon:isMobile}">
        <topLogo></topLogo>
        <div class="box" v-loading="loading">
            <h3 class="topTitle">{{ langPage['compte-oublie']['TXT_getmdp'] }}</h3>
            <el-form label-position="top" :model="sendData" :rules="rules" ref="formList">
                <el-form-item label="Email" prop="email">
                    <el-input class="input" v-model="sendData.email"></el-input>
                </el-form-item>
            </el-form>
            <vue-recaptcha class="recaptcha" ref="recaptcha" :sitekey="$common.recaptchaKey" @verify="recaptchaVerified"
                           :loadRecaptchaScript="true">
            </vue-recaptcha>
            <el-button class="sendBtn" @click="subData" :loading="loading">{{ langPage['compte-oublie']['TXT_valider'] }}</el-button>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import topLogo from "@/components/topLogo";

export default {
    name: "ResetPassword",
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            loading: false,
            sendData: {
                email: ''
            },
            rules: {
                email: [{required: true, message: "email can't null", trigger: "blur"}],//@TODO 错误语言提示分开
            },
            token: ''
        }
    },
    components: {VueRecaptcha, topLogo},
    computed: {
        langPage() {
            return this.$store.state.langPage
        }
    },
    created() {
        let recaptcha = document.createElement("script");

        recaptcha.src = "https://www.recaptcha.net/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit";

        recaptcha.async = true;

        recaptcha.defer = true;

        document.body.appendChild(recaptcha);
    },
    mounted() {
    },
    methods: {
        subData() {
            // this.token = 'sss';
            if (!this.token) {
                return this.$message.error(`robot verify can't skip`);
            }
            let that = this;
            this.$refs['formList'].validate(valify => {
                if (valify) {
                    let params = {
                        user_email: that.sendData.email,
                        token: that.token
                    }
                    try {
                        that.loading = true;
                        that.$api.auth.reset_password(params).then(res => {
                            that.loading = false;
                            that.token = '';
                            if (res.code === 0) {
                                that.$message.success(res.message);
                            } else that.$message.error(res.message);
                        })
                    } catch (e) {
                        that.loading = false;
                        that.token = '';
                    }
                }
            })
        },
        recaptchaVerified(token) {
            this.token = token;
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/ResetPassword.less">
</style>
